export const boxRound = {
  bold: {
    bottomLeft: '┗',
    bottomRight: '┛',
    horizontal: '━',
    topLeft: '┏',
    topRight: '┓',
    vertical: '┃'
  },
  classic: {
    bottomLeft: '+',
    bottomRight: '+',
    horizontal: '-',
    topLeft: '+',
    topRight: '+',
    vertical: '|'
  },
  double: {
    bottomLeft: '╚',
    bottomRight: '╝',
    horizontal: '═',
    topLeft: '╔',
    topRight: '╗',
    vertical: '║'
  },
  doubleSingle: {
    bottomLeft: '╘',
    bottomRight: '╛',
    horizontal: '═',
    topLeft: '╒',
    topRight: '╕',
    vertical: '│'
  },
  round: {
    bottomLeft: '╰',
    bottomRight: '╯',
    horizontal: '─',
    topLeft: '╭',
    topRight: '╮',
    vertical: '│'
  },
  single: {
    bottomLeft: '└',
    bottomRight: '┘',
    horizontal: '─',
    topLeft: '┌',
    topRight: '┐',
    vertical: '│'
  },
  singleDouble: {
    bottomLeft: '╙',
    bottomRight: '╜',
    horizontal: '─',
    topLeft: '╓',
    topRight: '╖',
    vertical: '║'
  }
};
